export default "__VITE_ASSET__BlozaT1S__"